module.exports = "<div class=\"\" style=\"padding: 150px 50px;position: relative;\">\r\n\r\n\r\n    <div class=\"col-s-12\">\r\n        <div class=\"col-s-12\" style=\"text-align: center;font-size: 14px;\">{{fnjiMedia.title}}</div>\r\n        <div class=\"col-s-12\" style=\"text-align: center;padding-bottom: 10px;\">{{fnjiMedia.publishDate}}</div>\r\n\r\n        <div class=\"col-s-12 media-wrapper\" v-html=\"fnjiMedia.detail\">\r\n\r\n        </div>\r\n\r\n    </div>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// C:/phpStudy/PHPTutorial/WWW/xbigger/fnjinew/build-v2/node_modules/text-loader!./fnjimedia-detail/component/main.html
// module id = 123
// module chunks = 4